export const NOTIFICATION = 'notification';

export const FEATURES = [
  {
    title: "Company",
    name: "company",
    isEnabled: false,
    subModules: [
      {
        title: "Info & Document",
        name: "info",
        isEnabled: false,
        functions: [
          {
            title: "View Info & Document",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Info & Document",
            name: "write",
            isEnabled: false,
            actions: [
              { title: "Edit Industry", name: "industry", isEnabled: false },
              { title: "Edit Contact", name: "contact", isEnabled: false },
              { title: "Edit Address", name: "address", isEnabled: false },
              { title: "Edit Company Logo", name: "company-logo", isEnabled: false }
            ]
          }
        ]
      },
      {
        title: "Product Page Setting",
        name: "product-page",
        isEnabled: false,
        functions: [
          {
            title: "View Product Page Setting",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Product Page Setting",
            name: "write",
            isEnabled: false,
            actions: [
              { title: "Edit Landing Page UI Setting", name: "landing-page-ui", isEnabled: false },
              {
                title: "Edit General",
                name: "general",
                isEnabled: false,
                subActions: [
                  { title: "Edit Default Displaying Profile", name: "default-profile", isEnabled: false }
                ]
              },
              { title: "Edit Company Contact", name: "company-contact", isEnabled: false },
              { title: "Edit Language", name: "language", isEnabled: false },
              { title: "Edit Company Social Media", name: "company-social-media", isEnabled: false },
              { title: "Edit Privacy Policy", name: "privacy-policy", isEnabled: false }
            ]
          }
        ]
      },
      {
        title: "Currency Setting",
        name: "currency",
        isEnabled: false,
        functions: [
          {
            title: "View Currency Setting",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Currency Setting",
            name: "write",
            isEnabled: false,
            actions: [
              { title: "Add Currency Setting", name: "add", isEnabled: false },
              {
                title: "Edit Currency Setting",
                name: "update",
                isEnabled: false,
                subActions: [
                  { title: "Update Currency Status", name: "currency-status", isEnabled: false }
                ]
              },
              { title: "Delete Currency Setting", name: "delete", isEnabled: false }
            ]
          }
        ]
      },
      {
        title: "Stock Module Setting",
        name: "stock-module",
        isEnabled: false,
        functions: [
          {
            title: "View Stock Module Setting",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Stock Module Setting",
            name: "write",
            isEnabled: false,
            actions: [
              { title: "Edit Email Settings", name: "email-settings", isEnabled: false },
              { title: "Edit Dealer Stockflow", name: "dealer-stockflow", isEnabled: false },
              { title: "Edit Dealer Incentive Points", name: "dealer-incentive-points", isEnabled: false },
              { title: "Edit Branch Stockflow", name: "branch-stockflow", isEnabled: false }
            ]
          }
        ]
      },
      {
        title: "Integration Setting",
        name: "integration",
        isEnabled: false,
        functions: [
          {
            title: "View Integration Setting",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Integration Setting",
            name: "write",
            isEnabled: false,
            actions: [
              { title: "API Endpoint Setting", name: "api-endpoint-setting", isEnabled: false },
              { title: "API Authorization", name: "api-authorization", isEnabled: false },
              { title: "Company Settings", name: "company-settings", isEnabled: false },
              { title: "Material Document API", name: "material-document-api", isEnabled: false },
              { title: "Product Details API", name: "product-details-api", isEnabled: false },
              { title: "Customer Sales Data API", name: "customer-sales-data-api", isEnabled: false }
            ]
          }
        ]
      },
      {
        title: "Consumer Engagement",
        name: "consumer-engagement",
        isEnabled: false,
        functions: [
          {
            title: "View Consumer Engagement",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Consumer Engagement",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Consumer Engagement",
                name: "update",
                isEnabled: false,
                subActions: [
                  { title: "Edit Credit Alerts", name: "credit-alerts", isEnabled: false }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: "Dashboard",
    name: "dashboard",
    isEnabled: false,
    subModules: [],
    functions: []
  },
  {
    title: "Reporting",
    name: "reporting",
    isEnabled: false,
    subModules: [],
    functions: []
  },
  {
    title: "Stock Overview",
    name: "stock-overview",
    isEnabled: false,
    subModules: [],
    functions: []
  },
  {
    title: "Employee",
    name: "employee",
    isEnabled: false,
    subModules: [],
    functions: [
      {
        title: "View Employee",
        name: "read",
        isEnabled: false,
        actions: []
      },
      {
        title: "Modify Employee",
        name: "write",
        isEnabled: false,
        actions: [
          {
            title: "Add Employee",
            name: "create",
            isEnabled: false
          },
          {
            title: "Edit Employee",
            name: "update",
            isEnabled: false,
            subActions: [
              {
                title: "Edit Role",
                name: "role",
                isEnabled: false
              },
              {
                title: "Edit Branch",
                name: "branch",
                isEnabled: false
              },
              {
                title: "Update Employee Status",
                name: "status",
                isEnabled: false
              }
            ]
          },
          {
            title: "Delete Employee",
            name: "delete",
            isEnabled: false
          }
        ]
      }
    ]
  },
  {
    title: "Branch",
    name: "branch",
    isEnabled: false,
    subModules: [
      {
        title: "Branch List",
        name: "listing",
        isEnabled: false,
        functions: [
          {
            title: "View Branch List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Branch List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Branch List",
                name: "create",
                isEnabled: false
              },
              {
                title: "Edit Branch List",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Owned By",
                    name: "owned-by",
                    isEnabled: false
                  },
                  {
                    title: "Edit Branch Name",
                    name: "branch-name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Description",
                    name: "description",
                    isEnabled: false
                  },
                  {
                    title: "Edit Address",
                    name: "address",
                    isEnabled: false
                  },
                  {
                    title: "Edit Contact",
                    name: "contact",
                    isEnabled: false
                  },
                  {
                    title: "Edit Email",
                    name: "email",
                    isEnabled: false
                  },
                  {
                    title: "Edit Timezone",
                    name: "timezone",
                    isEnabled: false
                  },
                  {
                    title: "Edit Social Media",
                    name: "social-media",
                    isEnabled: false
                  },
                  {
                    title: "Edit Branch Group",
                    name: "branch-group",
                    isEnabled: false
                  },
                  {
                    title: "Edit Landing Page Language",
                    name: "landing-page-language",
                    isEnabled: false
                  },
                  {
                    title: "Update Branch Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Group List",
        name: "group",
        isEnabled: false,
        functions: [
          {
            title: "View Group List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Group List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Group",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Group",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Group Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Group Branch",
                    name: "branch",
                    isEnabled: false
                  },
                  {
                    title: "Edit Stock Transfer Rules Settings",
                    name: "stock-transfer-rules-settings",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Delete Group",
                name: "delete",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Role & Access Control List",
        name: "role",
        isEnabled: false,
        functions: [
          {
            title: "View Role & Access Control List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Role & Access Control List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Role",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Role",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Role Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Assign Role Access Rights",
                    name: "access-rights",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Delete Role",
                name: "delete",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      }
    ],
    functions: []
  },
  {
    title: "Organisation Structure",
    name: "organisation-structure",
    isEnabled: false,
    subModules: [],
    functions: []
  },
  {
    title: "QR code",
    name: "qr",
    isEnabled: false,
    subModules: [
      {
        title: "Serial Number List",
        name: "serial-number",
        isEnabled: false,
        functions: [
          {
            title: "View Serial Number List",
            name: "read",
            actions: []
          },
          {
            title: "Modify Serial Number List",
            name: "write",
            actions: [
              {
                title: "Generate Serial Number",
                name: "create"
              },
              {
                title: "Edit Serial Number",
                name: "update",
                subActions: [
                  {
                    title: "Reset Scan Count",
                    name: "reset-scan-count"
                  }
                ]
              },
              {
                title: "Suspend / Reactivate Serial Number",
                name: "suspend-reactivate"
              }
            ]
          }
        ]
      },
      {
        title: "Serial Number Batch List",
        name: "batch",
        isEnabled: false,
        functions: [
          {
            title: "View Serial Number Batch List",
            name: "read",
            actions: []
          },
          {
            title: "Modify Serial Number Batch List",
            name: "write",
            actions: [
              {
                title: "Edit Serial Number Batch List",
                name: "update",
                subActions: [
                  {
                    title: "Update App Authenticator",
                    name: "app-authenticator"
                  },
                  {
                    title: "Update Product Page Preview",
                    name: "product-page-preview"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Saved Pattern List",
        name: "tag",
        isEnabled: false,
        functions: [
          {
            title: "View Saved Pattern List",
            name: "read",
            actions: []
          },
          {
            title: "Add Saved Pattern List",
            name: "write",
            actions: []
          }
        ]
      },
      {
        title: "Assign List",
        name: "assign",
        isEnabled: false,
        functions: []
      },
      {
        title: "Unassign List",
        name: "unassign",
        isEnabled: false,
        functions: [
          {
            title: "View Unassign List",
            name: "read"
          },
          {
            title: "Modify Unassign List",
            name: "write",
            actions: [
              {
                title: "Unassign Serial Number",
                name: "unassign",
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Additional Info List",
        name: "additional-info",
        isEnabled: false,
        functions: [
          {
            title: "View Additional Info List",
            name: "read",
            actions: []
          },
          {
            title: "Modify Additional Info List",
            name: "write",
            actions: [
              {
                title: "Add Additional Info",
                name: "create",
                subActions: []
              },
              {
                title: "Edit Additional Info",
                name: "update",
                subActions: [
                  {
                    title: "Edit Additional Info Title",
                    name: "title"
                  },
                  {
                    title: "Edit Additional Info Description",
                    name: "description"
                  }
                ]
              },
              {
                title: "Delete Additional Info",
                name: "delete"
              }
            ]
          }
        ]
      }
    ],
    functions: []
  },
  {
    title: "Product",
    name: "product",
    isEnabled: false,
    subModules: [
      {
        title: "Product List",
        name: "listing",
        isEnabled: false,
        functions: [
          {
            title: "View Product List",
            name: "read",
            actions: []
          },
          {
            title: "Modify Product List",
            name: "write",
            actions: [
              {
                title: "Add Product",
                name: "create",
                subActions: []
              },
              {
                title: "Edit Product",
                name: "update",
                subActions: [
                  {
                    title: "Edit Branch",
                    name: "branch"
                  },
                  {
                    title: "Edit Product Name",
                    name: "name"
                  },
                  {
                    title: "Edit Category",
                    name: "category"
                  },
                  {
                    title: "Edit Brand & Model",
                    name: "brand-model"
                  },
                  {
                    title: "Edit Attributes",
                    name: "attributes"
                  },
                  {
                    title: "Edit Description",
                    name: "description"
                  },
                  {
                    title: "Edit SKU",
                    name: "sku"
                  },
                  {
                    title: "Edit Scan Limit",
                    name: "scan-limit"
                  },
                  {
                    title: "Edit Dealer Incentive Point",
                    name: "dealer-incentive-point"
                  },
                  {
                    title: "Edit Warranty Name",
                    name: "warranty-name"
                  },
                  {
                    title: "Update Product Status",
                    name: "status"
                  }
                ]
              },
              {
                title: "Delete Product",
                name: "delete",
                subActions: []
              },
              {
                title: "Assign Serial Number",
                name: "assign",
                subActions: []
              },
              {
                title: "Publish / Unpublish Product",
                name: "publish-unpublish",
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Product Landing Page",
        name: "landing-page",
        isEnabled: false,
        functions: [
          {
            title: "View Product Landing Page",
            name: "read",
            actions: []
          },
          {
            title: "Modify Product Landing Page",
            name: "write",
            actions: [
              {
                title: "Update Template Used",
                name: "template"
              },
              {
                title: "Edit Component",
                name: "component"
              },
              {
                title: "Edit Setting",
                name: "setting"
              }
            ]
          }
        ]
      },
      {
        title: "Category List",
        name: "category",
        isEnabled: false,
        functions: [
          {
            title: "View Category List",
            name: "read",
            actions: []
          },
          {
            title: "Modify Category List",
            name: "write",
            actions: [
              {
                title: "Add Category",
                name: "create",
                subActions: []
              },
              {
                title: "Edit Category",
                name: "update",
                subActions: [
                  {
                    title: "Edit Category Name",
                    name: "name"
                  },
                  {
                    title: "Update Category Status",
                    name: "status"
                  }
                ]
              },
              {
                title: "Delete Category",
                name: "delete",
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Brand & Model List",
        name: "brand-model",
        isEnabled: false,
        functions: [
          {
            title: "View Brand & Model List",
            name: "read",
            actions: []
          },
          {
            title: "Modify Brand & Model List",
            name: "write",
            actions: [
              {
                title: "Add Brand & Model",
                name: "create",
                subActions: []
              },
              {
                title: "Edit Brand & Model",
                name: "update",
                subActions: [
                  {
                    title: "Edit Brand Name",
                    name: "brand-name"
                  },
                  {
                    title: "Edit Description",
                    name: "description"
                  },
                  {
                    title: "Edit Models",
                    name: "models"
                  },
                  {
                    title: "Edit Brand Image",
                    name: "brand-image"
                  },
                  {
                    title: "Update Brand & Model Status",
                    name: "status"
                  }
                ]
              },
              {
                title: "Delete Brand & Model",
                name: "delete",
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Attributes List",
        name: "attribute",
        isEnabled: false,
        functions: [
          {
            title: "View Attributes List",
            name: "read",
            actions: []
          },
          {
            title: "Modify Attributes List",
            name: "write",
            actions: [
              {
                title: "Add Attributes",
                name: "create",
                subActions: []
              },
              {
                title: "Edit Attributes",
                name: "update",
                subActions: [
                  {
                    title: "Edit Attribute Name",
                    name: "name"
                  },
                  {
                    title: "Edit Attribute Option",
                    name: "option"
                  },
                  {
                    title: "Update Attribute Status",
                    name: "status"
                  }
                ]
              },
              {
                title: "Delete Attributes",
                name: "delete",
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Landing Page Template List",
        name: "landing-template",
        isEnabled: false,
        functions: [
          {
            title: "View Landing Page Template List",
            name: "read",
            actions: []
          },
          {
            title: "Modify Landing Page Template List",
            name: "write",
            actions: [
              {
                title: "Add Landing Page Template",
                name: "create",
                subActions: []
              },
              {
                title: "Edit Landing Page Template",
                name: "update",
                subActions: [
                  {
                    title: "Edit Name",
                    name: "name"
                  },
                  {
                    title: "Edit Assigned Products",
                    name: "assigned-products"
                  },
                  {
                    title: "Edit Component",
                    name: "component"
                  },
                  {
                    title: "Edit Setting",
                    name: "setting"
                  }
                ]
              },
              {
                title: "Delete Landing Page Template",
                name: "delete",
                subActions: []
              }
            ]
          }
        ]
      }
    ],
    functions: []
  },
  {
    title: "Trackco (Portal)",
    name: "trackco-portal",
    isEnabled: false,
    subModules: [
      {
        title: "Product Branch Inventory List",
        name: "branch-inventory",
        isEnabled: false,
        functions: []
      },
      {
        title: "Product Dealer Inventory List",
        name: "dealer-inventory",
        isEnabled: false,
        functions: []
      },
      {
        title: "Product Summary by Branch List",
        name: "branch-summary",
        isEnabled: false,
        functions: []
      },
      {
        title: "Product Summary by Dealer List",
        name: "dealer-summary",
        isEnabled: false,
        functions: []
      },
      {
        title: "Package List",
        name: "package",
        isEnabled: false,
        functions: []
      },
      {
        title: "Boxes List",
        name: "boxes",
        isEnabled: false,
        functions: []
      },
      {
        title: "Loose Item List",
        name: "loose-item",
        isEnabled: false,
        functions: []
      },
      {
        title: "Checkout List",
        name: "checkout",
        isEnabled: false,
        functions: [
          {
            title: "View Checkout List",
            name: "read",
            isEnabled: false
          },
          {
            title: "Modify Checkout List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Checkout List",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Delivery Info",
                    name: "delivery-info",
                    isEnabled: false
                  },
                  {
                    title: "Edit Remark",
                    name: "remark",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Dealer List",
        name: "dealer",
        isEnabled: false,
        functions: [
          {
            title: "View Dealer List",
            name: "read",
            isEnabled: false
          },
          {
            title: "Modify Dealer List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Dealer",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Dealer",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Dealer Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Update Dealer Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Edit Dealer Incentive Point",
                name: "update-incentive-point",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Incentive Point Adjustment",
                    name: "adjustment",
                    isEnabled: false
                  },
                  {
                    title: "Edit Remark",
                    name: "remark",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Dealer Incentive Program List",
        name: "dealer-incentive-program",
        isEnabled: false,
        functions: [
          {
            title: "View Dealer Incentive Program List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Dealer Incentive Program List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Dealer Incentive Program",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Dealer Incentive Program Detail",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Program Name",
                    name: "program-name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Assign Product",
                    name: "assigned-product",
                    isEnabled: false
                  },
                  {
                    title: "Edit Distribute Dealers Incentive Points",
                    name: "distribute-dealers-incentive-points",
                    isEnabled: false
                  },
                  {
                    title: "Update Dealer Incentive Program Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Delete Dealer Incentive Program",
                name: "delete",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Reward List",
        name: "reward",
        isEnabled: false,
        functions: [
          {
            title: "View Reward List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Reward List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Reward",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Reward",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Thumbnail Photo",
                    name: "thumbnail-photo",
                    isEnabled: false
                  },
                  {
                    title: "Edit Reward Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Branch",
                    name: "branch",
                    isEnabled: false
                  },
                  {
                    title: "Edit Points",
                    name: "points",
                    isEnabled: false
                  },
                  {
                    title: "Edit Display Date",
                    name: "display-date",
                    isEnabled: false
                  },
                  {
                    title: "Edit Validity Date",
                    name: "validity-date",
                    isEnabled: false
                  },
                  {
                    title: "Edit Stock Quantity",
                    name: "stock-quantity",
                    isEnabled: false
                  },
                  {
                    title: "Edit Number of redemption limit per dealer",
                    name: "redemption-limit",
                    isEnabled: false
                  },
                  {
                    title: "Edit Description",
                    name: "description",
                    isEnabled: false
                  },
                  {
                    title: "Edit Terms & Conditions",
                    name: "terms-conditions",
                    isEnabled: false
                  },
                  {
                    title: "Update Reward Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Delete Reward",
                name: "delete",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Orders List",
        name: "order",
        isEnabled: false,
        functions: [
          {
            title: "View Orders List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Orders List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Orders List",
                name: "update",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: "Trackco (Mobile)",
    name: "trackco-mobile",
    isEnabled: false,
    subModules: [
      {
        title: 'Product List',
        name: 'product',
        isEnabled: false,
        functions: [
          {
            title: 'View Product List',
            name: 'read',
            isEnabled: false,
            actions: []
          },
        ]
      },
      {
        title: "Package List",
        name: "package",
        isEnabled: false,
        functions: [
          {
            title: "View Package List",
            name: "read",
            isEnabled: false,
          },
          {
            title: "Modify Package List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Packing",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Delete Package",
                name: "delete",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Box List",
        name: "box",
        isEnabled: false,
        functions: [
          {
            title: "View Box List",
            name: "read",
            isEnabled: false,
          },
          {
            title: "Modify Box List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Boxing",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Delete Box",
                name: "delete",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Orders",
        name: "order",
        isEnabled: false,
        functions: [
          {
            title: "View Orders List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Response Orders",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Stock Out",
        name: "stock-out",
        isEnabled: false,
        functions: [
          {
            title: "View Stock Out List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Stock Out List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Stock Out",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Cancel Stock Out",
                name: "cancel",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Recall",
        name: "recall",
        isEnabled: false,
        functions: [
          {
            title: "View Recall List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Add Recall",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Request Stock Transfer",
        name: "request-transfer",
        isEnabled: false,
        functions: [
          {
            title: "View Stock Transfer List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Stock Transfer List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Request Transfer",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Cancel Request Transfer",
                name: "cancel",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Approve / Reject Branch Request",
                name: "process",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Transfer Stock",
        name: "transfer",
        isEnabled: false,
        functions: [
          {
            title: "View Transfer Stock List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Add Transfer Stock",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Receive Stock Transfer",
        name: "receive-transfer",
        isEnabled: false,
        functions: [
          {
            title: "View Receive Stock Transfer List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Receive Stock Transfer List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Request Stock",
                name: "request",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Scan to Receive",
                name: "scan",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Stocktake",
        name: "stocktake",
        isEnabled: false,
        functions: [
          {
            title: "View Stocktake List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Add Stocktake",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Checkout",
        name: "checkout",
        isEnabled: false,
        functions: [
          {
            title: "View Checkout List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Checkout",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Checkout",
                name: "create",
                isEnabled: false,
                subActions: [],
              },
              {
                title: "Add Consumer",
                name: "create-consumer",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Consumer",
                name: "update-consumer",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Full Name",
                    name: "full-name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Mobile Number",
                    name: "mobile-number",
                    isEnabled: false
                  },
                  {
                    title: "Edit Email",
                    name: "email",
                    isEnabled: false
                  },
                  {
                    title: "Edit Date of Birth",
                    name: "dob",
                    isEnabled: false
                  },
                  {
                    title: "Edit Gender",
                    name: "gender",
                    isEnabled: false
                  },
                  {
                    title: "Edit Address",
                    name: "address",
                    isEnabled: false
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: "Assign Serial Number",
        name: "assign",
        isEnabled: false,
        functions: [
          {
            title: "View Assign Serial Number List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Assign Serial Number",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Unassign Serial Number",
        name: "unassign",
        isEnabled: false,
        functions: [
          {
            title: "View Unassign Serial Number List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Unassign Serial Number",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Warranty Item Replacement",
        name: "warranty-replacement",
        isEnabled: false,
        functions: [
          {
            title: "View Warranty Item Replacement List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Warranty Item Replacement List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Scan to Replace Item",
                name: "replace",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Handoff",
                name: "handoff",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Package Traceability",
        name: "package-traceability",
        isEnabled: false,
        functions: []
      },
      {
        title: "Dealers",
        name: "dealers",
        isEnabled: false,
        functions: []
      },
      {
        title: "Business Insights",
        name: "business-insights",
        isEnabled: false,
        functions: []
      }
    ]
  },
  {
    title: "Market Place",
    name: "marketplace",
    isEnabled: false,
    subModules: [],
    functions: [
      {
        title: "View Market Place",
        name: "read",
        isEnabled: false,
        actions: []
      },
      {
        title: "Market Place Purchase",
        name: "write",
        isEnabled: false,
        actions: [
          {
            title: "Purchase QR Code Credit",
            name: "qr-code-credit-purchase",
            isEnabled: false
          },
          {
            title: "Purchase SMS Credit",
            name: "sms-credit-purchase",
            isEnabled: false
          },
          {
            title: "Swap Subscription Plans",
            name: "subscription-plans-swap",
            isEnabled: false
          }
        ]
      }
    ]
  },
  {
    title: "Consumer",
    name: "consumer",
    isEnabled: false,
    subModules: [
      {
        title: "Consumer List",
        name: "consumer",
        isEnabled: false,
        functions: [
          {
            title: "View Consumer List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Consumer List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Consumer Loyalty Point",
                name: "loyalty-point",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Loyalty Point Adjustment",
                    name: "update",
                    isEnabled: false
                  },
                  {
                    title: "Edit Remark",
                    name: "update-remark",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    functions: []
  },
  {
    title: "Counterfeit Report",
    name: "counterfeit",
    isEnabled: false,
    subModules: [
      {
        title: "Counterfeit Report List",
        name: "listing",
        isEnabled: false,
        functions: [
          {
            title: "View Counterfeit Report List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Counterfeit Report List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Counterfeit Report",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Admin Remark",
                    name: "admin-remark",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    functions: []
  },
  {
    title: "CampaignV2",
    name: "campaign-v2",
    isEnabled: false,
    subModules: [
      {
        title: "Lucky Draw List",
        name: "lucky-draw",
        isEnabled: false,
        functions: [
          {
            title: "View Lucky Draw List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Lucky Draw List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Traditional Raffle",
                name: "create-traditional-raffle",
                isEnabled: false
              },
              {
                title: "Add Instant Win",
                name: "create-instant-win",
                isEnabled: false
              },
              {
                title: "Duplicate Lucky Draw",
                name: "duplicate",
                isEnabled: false
              },
              {
                title: "Edit Traditional Raffle Detail",
                name: "update-traditional-raffle",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Basic Information",
                    name: "basic",
                    isEnabled: false
                  },
                  {
                    title: "Edit Period Information",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Prize Information",
                    name: "prize",
                    isEnabled: false
                  },
                  {
                    title: "Edit Participant Information",
                    name: "participant",
                    isEnabled: false
                  },
                  {
                    title: "Edit Product Binding",
                    name: "products",
                    isEnabled: false
                  },
                  {
                    title: "Edit Winner",
                    name: "winner",
                    isEnabled: false
                  },
                  {
                    title: "Update Traditional Raffle Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Edit Instant Win Detail",
                name: "update-instant-win",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Basic Information",
                    name: "basic",
                    isEnabled: false
                  },
                  {
                    title: "Edit Period Information",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Prize Information",
                    name: "prize",
                    isEnabled: false
                  },
                  {
                    title: "Edit Win Rate Information",
                    name: "win-rate",
                    isEnabled: false
                  },
                  {
                    title: "Edit Participant Information",
                    name: "participant",
                    isEnabled: false
                  },
                  {
                    title: "Edit Product Binding",
                    name: "products",
                    isEnabled: false
                  },
                  {
                    title: "Edit Winner",
                    name: "winner",
                    isEnabled: false
                  },
                  {
                    title: "Update Instant Win Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Delete Traditional Raffle",
                name: "delete-traditional-raffle",
                isEnabled: false
              },
              {
                title: "Delete Instant Win",
                name: "delete-instant-win",
                isEnabled: false
              }
            ]
          }
        ]
      }
    ],
    functions: []
  },
  {
    title: "Campaign",
    name: "campaign",
    isEnabled: false,
    subModules: [
      {
        title: "Survey List",
        name: "survey",
        isEnabled: false,
        subActions: [],
        functions: [
          {
            title: "View Survey List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Survey List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Survey",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Survey Detail",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Survey Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Description",
                    name: "description",
                    isEnabled: false
                  },
                  {
                    title: "Edit Assign Product",
                    name: "assign-product",
                    isEnabled: false
                  },
                  {
                    title: "Edit Survey Period",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Question",
                    name: "question",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Lucky Draw List",
        name: "lucky-draw",
        isEnabled: false,
        subActions: [],
        functions: [
          {
            title: "View Lucky Draw List",
            name: "read",
            isEnabled: false,
            actions: [],
          },
          {
            title: "Modify Lucky Draw List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Lucky Draw",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Lucky Draw Detail",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Lucky Draw Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Event Period",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Description",
                    name: "description",
                    isEnabled: false
                  },
                  {
                    title: "Edit Lucky Draw Image",
                    name: "image",
                    isEnabled: false
                  },
                  {
                    title: "Edit Assign Product",
                    name: "assign-product",
                    isEnabled: false
                  },
                  {
                    title: "Edit Terms & Conditions",
                    name: "terms-conditions",
                    isEnabled: false
                  },
                  {
                    title: "Edit Participant Registration Form",
                    name: "participant-registration-form",
                    isEnabled: false
                  },
                  {
                    title: "Update Lucky Draw Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Set Prize",
                name: "prize",
                isEnabled: false,
                subActions: [
                  {
                    title: "View Prize",
                    name: "read",
                    isEnabled: false
                  },
                  {
                    title: "Edit Prize",
                    name: "write",
                    isEnabled: false
                  },
                  {
                    title: "Delete Prize",
                    name: "delete",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Set Winner",
                name: "winner",
                isEnabled: false,
                subActions: [
                  {
                    title: "View Winner",
                    name: "read",
                    isEnabled: false
                  },
                  {
                    title: "Edit Winner",
                    name: "write",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Start Live Draw",
                name: "live-draw",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Instant Lucky Draw List",
        name: "instant-lucky-draw",
        isEnabled: false,
        subActions: [],
        functions: [
          {
            title: "View Instant Lucky Draw List",
            name: "read",
            isEnabled: false,
            actions: [],
          },
          {
            title: "Modify Instant Lucky Draw List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Instant Lucky Draw",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Instant Lucky Draw Detail",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Instant Lucky Draw Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Event Period",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Description",
                    name: "description",
                    isEnabled: false
                  },
                  {
                    title: "Edit Instant Lucky Draw Image",
                    name: "image",
                    isEnabled: false
                  },
                  {
                    title: "Edit Assign Product",
                    name: "products",
                    isEnabled: false
                  },
                  {
                    title: "Edit Terms & Conditions",
                    name: "tnc",
                    isEnabled: false
                  },
                  {
                    title: "Change Game Template",
                    name: "game-template",
                    isEnabled: false
                  },
                  {
                    title: "Edit Participant Registration Form",
                    name: "registration-form",
                    isEnabled: false
                  },
                  {
                    title: "Update Lucky Draw Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Set Prize",
                name: "prize",
                isEnabled: false,
                subActions: [
                  {
                    title: "View Prize",
                    name: "read",
                    isEnabled: false
                  },
                  {
                    title: "Edit Prize",
                    name: "write",
                    isEnabled: false
                  },
                  {
                    title: "Delete Prize",
                    name: "delete",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Set Winner",
                name: "winner",
                isEnabled: false,
                subActions: [
                  {
                    title: "View Winner",
                    name: "read",
                    isEnabled: false
                  },
                  {
                    title: "Edit Winner",
                    name: "write",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Publish",
                name: "publish",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Loyalty Points List",
        name: "loyalty-point",
        isEnabled: false,
        subActions: [],
        functions: [
          {
            title: "View Loyalty Points List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Loyalty Points List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Loyalty Points",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Loyalty Points Detail",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Points",
                    name: "points",
                    isEnabled: false
                  },
                  {
                    title: "Edit Assign Product",
                    name: "assign-product",
                    isEnabled: false
                  },
                  {
                    title: "Update Loyalty Point Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Bonanza List",
        name: "bonanza",
        isEnabled: false,
        subActions: [],
        functions: [
          {
            title: "View Bonanza List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Bonanza List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Bonanza",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Bonanza Detail",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Bonanza",
                    name: "details",
                    isEnabled: false
                  },
                  {
                    title: "Edit Period",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Assign Module",
                    name: "assign-module",
                    isEnabled: false
                  },
                  {
                    title: "Update Bonanza Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Gift List",
        name: "gift",
        isEnabled: false,
        subActions: [],
        functions: [
          {
            title: "View Gift List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Gift List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Gift",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Gift",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Gift Photo",
                    name: "photo",
                    isEnabled: false
                  },
                  {
                    title: "Edit Gift Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Description",
                    name: "description",
                    isEnabled: false
                  },
                  {
                    title: "Edit Period",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Gift Per Customer",
                    name: "per-customer",
                    isEnabled: false
                  },
                  {
                    title: "Edit Points Required",
                    name: "points-required",
                    isEnabled: false
                  },
                  {
                    title: "Edit Stock Quantity",
                    name: "stock-quantity",
                    isEnabled: false
                  },
                  {
                    title: "Update Gift Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Gift Redemption List",
        name: "gift-redemption",
        isEnabled: false,
        subActions: [],
        functions: [
          {
            title: "View Gift Redemption List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Gift Redemption List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Gift Redemption Detail",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Update Gift Redemption Status",
                    name: "status",
                    isEnabled: false
                  },
                  {
                    title: "Edit delivery update",
                    name: "delivery-update",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Point Cut List",
        name: "point-cut",
        isEnabled: false,
        subActions: [],
        functions: [
          {
            title: "View Point Cut List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Point Cut List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Point Cut",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Point Cut Detail",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Points Cut",
                    name: "points",
                    isEnabled: false
                  },
                  {
                    title: "Update Point Cut Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: "Warranty",
    name: "warranty",
    isEnabled: false,
    subModules: [
      {
        title: "Warranty List",
        name: "listing",
        isEnabled: false,
        functions: [
          {
            title: "View Warranty List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Warranty List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Warranty Settings",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Warranty Name",
                    name: "name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Warranty Period",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Require Approval",
                    name: "require-approval",
                    isEnabled: false
                  },
                  {
                    title: "Edit Pre-register Warranty upon Checkout",
                    name: "pre-register",
                    isEnabled: false
                  },
                  {
                    title: "Edit Validate with DO Number",
                    name: "validate-do-number",
                    isEnabled: false
                  },
                  {
                    title: "Edit Enable Item Replacement Process",
                    name: "enable-item-replacement",
                    isEnabled: false
                  },
                  {
                    title: "Edit Assign Product",
                    name: "assign-product",
                    isEnabled: false
                  },
                  {
                    title: "Edit Warranty Terms & Conditions",
                    name: "tnc",
                    isEnabled: false
                  },
                  {
                    title: "Edit Warranty Reason Option",
                    name: "reason-option",
                    isEnabled: false
                  },
                  {
                    title: "Edit Receive email notification upon registration",
                    name: "email-notification",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Edit Warranty Registration Form Settings",
                name: "update-registration-form",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Field Name",
                    name: "field-name",
                    isEnabled: false
                  },
                  {
                    title: "Edit Mandatory",
                    name: "mandatory",
                    isEnabled: false
                  },
                  {
                    title: "Edit Visible",
                    name: "visible",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Add Warranty",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Add Warranty Extension",
                name: "create-extension",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Warranty Extension",
                name: "update-extension",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Extension Period",
                    name: "period",
                    isEnabled: false
                  },
                  {
                    title: "Edit Effective Period",
                    name: "effective-period",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Generate Code",
                name: "generate-code",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Pre-register",
                name: "pre-register",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Validate with DO Number",
                name: "validate-do-number",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      },
      {
        title: "Warrantee List",
        name: "warrantee",
        isEnabled: false,
        functions: [
          {
            title: "View Warrantee List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Warrantee List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Warrantee Detail Approval",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Update Warranty Status",
                    name: "status",
                    isEnabled: false
                  },
                  {
                    title: "Update Registration Status",
                    name: "registration-status",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Consumer Claim List",
        name: "claim",
        isEnabled: false,
        functions: [
          {
            title: "View Consumer Claim List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Consumer Claim List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Consumer Claim",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Remark",
                    name: "remark",
                    isEnabled: false
                  },
                  {
                    title: "Edit Contact Number",
                    name: "contact-number",
                    isEnabled: false
                  },
                  {
                    title: "Edit Date of Purchase",
                    name: "date-of-purchase",
                    isEnabled: false
                  },
                  {
                    title: "Edit Coverage Period",
                    name: "coverage-period",
                    isEnabled: false
                  },
                  {
                    title: "Update Claim Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Edit Consumer Reimbursement",
                name: "write-reimbursement",
                isEnabled: false,
                subActions: [
                  {
                    title: "Create Warranty Reimbursement Form",
                    name: "create",
                    isEnabled: false
                  },
                  {
                    title: "Update Reimbursement Status",
                    name: "update-status",
                    isEnabled: false
                  }
                ]
              },
              {
                title: "Company-Wide Claim Approve",
                name: "claim-approve-company",
                isEnabled: false
              }
            ]
          },
        ]
      },
      {
        title: "Item Replacement Handoff List",
        name: "replacement-handoff",
        isEnabled: false,
        functions: [
          {
            title: "View Item Replacement Handoff List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Item Replacement Handoff List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Item Replacement Handoff",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Handoff",
                    name: "handoff",
                    isEnabled: false
                  },
                  {
                    title: "Replace",
                    name: "replace",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        title: "Warranty Reimbursement List",
        name: "reimbursement",
        isEnabled: false,
        functions: [
          {
            title: "View Warranty Reimbursement List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Warranty Reimbursement List",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Add Warranty Reimbursement",
                name: "create",
                isEnabled: false,
                subActions: []
              },
              {
                title: "Edit Warranty Reimbursement",
                name: "update",
                isEnabled: false,
                subActions: [
                  {
                    title: "Edit Remark",
                    name: "remark",
                    isEnabled: false
                  },
                  {
                    title: "Edit Contact Number",
                    name: "contact-number",
                    isEnabled: false
                  },
                  {
                    title: "Edit Coverage Period",
                    name: "coverage-period",
                    isEnabled: false
                  },
                  {
                    title: "Update Reimbursement Status",
                    name: "status",
                    isEnabled: false
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: "External API Access",
    name: "external",
    type: "self::TYPE_CORE",
    isEnabled: false,
    subModules: [],
    functions: []
  },
  {
    title: "DKSH",
    name: "dksh",
    type: "self::TYPE_CUSTOMISED",
    isEnabled: false,
    subModules: [
      {
        title: "DKSH Product List",
        name: "product",
        isEnabled: false,
        functions: [
          {
            title: "View DKSH Product List",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Import Product",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Invoice",
        name: "invoice",
        isEnabled: false,
        functions: []
      },
      {
        title: "Trackco Invoice",
        name: "trackco-invoice",
        isEnabled: false,
        functions: [
          {
            title: "View Trackco Invoice",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Modify Trackco Invoice",
            name: "write",
            isEnabled: false,
            actions: [
              {
                title: "Edit Trackco Invoice",
                name: "update",
                isEnabled: false,
                subActions: []
              }
            ]
          }
        ]
      }
    ],
    functions: []
  },
  {
    title: "Philips",
    name: "philips",
    type: "self::TYPE_CUSTOMISED",
    isEnabled: false,
    subModules: [
      {
        title: "Delivery Note",
        name: "delivery-note",
        isEnabled: false,
        functions: [
          {
            title: "View Delivery Note",
            name: "read",
            isEnabled: false,
            actions: []
          },
          {
            title: "Add Delivery Note",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      }
    ],
    functions: []
  },
  {
    title: "Prife",
    name: "prife",
    type: "self::TYPE_CUSTOMISED",
    isEnabled: false,
    subModules: [
      {
        title: "Reimbursement",
        name: "reimbursement",
        isEnabled: false,
        functions: [
          {
            title: "Approve Company-wide",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Registration",
        name: "registration",
        isEnabled: false,
        functions: [
          {
            title: "Company-wide Registration Approve",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      },
      {
        title: "Replacement",
        name: "replacement",
        isEnabled: false,
        functions: [
          {
            title: "Company-wide Replacement",
            name: "write",
            isEnabled: false,
            actions: []
          }
        ]
      }
    ],
    functions: []
  }
];
